import React from 'react';
import { CalendarDays, Map } from 'lucide-react';
import { Button } from './ui/button';

export const FestivalViewToggle = ({ view, onViewChange }) => {
  return (
    <section className="pb-8">
      <div className="container-custom">
        <div className="flex justify-end">
          <div className="inline-flex rounded-xl bg-section-bg p-1 shadow-sm">
            <Button
              type="button"
              variant={view === 'calendar' ? 'default' : 'ghost'}
              className="rounded-lg"
              onClick={() => onViewChange('calendar')}
            >
              <CalendarDays className="h-4 w-4" />
              Kalender
            </Button>
            <Button
              type="button"
              variant={view === 'map' ? 'default' : 'ghost'}
              className="rounded-lg"
              onClick={() => onViewChange('map')}
            >
              <Map className="h-4 w-4" />
              Kort
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
